import React from "react";
import picture from "../../images/bclogo.png"
import { motion } from 'framer-motion';
import Socials from "../general/socials.tsx"

function Parallax() {

    return (
    
            <div className="content-center grid grid-cols-2 h-128 bg-fixed bg-center bg-parallax bg-cover">
                <motion.div 
                className="justify-self-end"
                    variants={{
                    hidden: { opacity: 0, x: -100 },
                    visible: { opacity: 1, x: 0 },
                    }}
                    initial="hidden"
                    animate="visible"
                    transition={{
                        duration: 0.5,
                    }}>
                        <img
                            className="shadow-xl h-96 w-96 rounded-full object-cover object-center"
                            src={picture}
                            alt="Vihas Veggalam"
                        />
                </motion.div>
                <div className="ml-10 flex flex-row text-left items-center">
                    <motion.div 
                    variants={{
                        hidden: { opacity: 0, x: 100 },
                        visible: { opacity: 1, x: 0 },
                        }}
                        initial="hidden"
                        animate="visible"
                        transition={{
                            duration: 0.5,
                        }}>
                        <div>
                            <p className=" text-white text-2xl sm:text-3xl md:text-6xl font-extrabold pb-5">Vihas Veggalam</p>
                            <p className="hidden sm:block text-white text-xl md:text-3xl font-bold">A bit about me</p>
                            <p className="hidden sm:block text-white text-md md:text-xl max-w-96 w-fit">I am an Electrical and Computer Engineering student at the University of Texas at Austin in Austin, Texas. I am currently working on analog circuits to decompose sound waves.</p>
                            <Socials/>

                        </div>
                    </motion.div>
                </div>
            </div>

    );
}
export default Parallax;